module.exports = __webpack_public_path__ + "img/price.68a17342.svg";